const ENVIRONMENT = {
  sandbox: 'sandbox',
  prod: 'production',
};

export { ENVIRONMENT };
